<template>
  <v-row align="center" justify="center" v-if="!isLoggedIn">
    <v-col cols="12" sm="8" md="6" lg="5">
      <v-card class="elevation-12">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Clinux</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items class="d-none d-sm-block">
            {{ setup.ds_dicomvix_title }}
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="d-flex justify-center">
          <img :src="logo" alt="Logo" style="max-width: 90%" />
        </v-card-text>
        <v-card-text>
          <v-form>
            <v-text-field
              label="Usuário"
              v-model="formLogin.id"
              prepend-icon="person"
              autofocus
            />
            <v-text-field
              id="password"
              label="Senha"
              :type="showPassword ? 'text' : 'password'"
              v-model="formLogin.pw"
              prepend-icon="lock"
              @keydown.enter="submitLogin()"
            >
              <template #append>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind='attrs'
                      v-on='on'
                      @click='showPassword = !showPassword'
                    >
                      <v-icon>
                        {{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ showPassword ? 'Esconder Senha' : 'Mostrar Senha' }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div v-if="authStatus">{{ authStatus }}</div>
          <v-spacer />
          <v-btn small color="primary" @click="submitLogin">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  data: () => ({
    formLogin: {
      id: '',
      pw: ''
    },
    showPassword: false
  }),
  created () {
    if (this.isLoggedIn) this.$router.push({ name: 'clinux' })
    this.exibeLogo()
  },
  computed: {
    ...mapGetters('login', ['authStatus', 'isLoggedIn']),
    ...mapState('login', ['logo', 'setup'])
  },
  methods: {
    ...mapActions('login', ['exibeLogo', 'login']),
    submitLogin () {
      this.login(this.formLogin)
        .then(response => {
          if (response.data.length && !response.data[0].Erro) {
            this.$router.push({ name: 'clinux' })
          }
        })
    }
  }
}
</script>
